import './Archive.scss';

ComponentManager.init(document.body);
